import { Navigate, useSearchParams } from 'react-router'
import { Ingreso } from './Ingreso'
import { destinoInicial, useSesion } from './useSesion'
import { Cargando } from './Cargando'

/**
 * Raíz y /ingreso — decide a dónde va cada persona (§5.4, §8.1):
 *  · sin sesión → tarjeta de ingreso (o el estado que traiga la URL);
 *  · cliente sin proyectos → tarjeta con "Salir y probar con otra cuenta";
 *  · sesión rechazada por el portal → "Tu acceso a este proyecto cambió";
 *  · el resto → su destino inicial.
 */
export function Entrada() {
  const sesion = useSesion()
  const [params] = useSearchParams()

  if (sesion.estado === 'cargando') return <Cargando />

  if (sesion.estado === 'anonimo') {
    const cancelado = params.get('estado') === 'cancelado'
    return <Ingreso estado={cancelado ? { tipo: 'cancelado' } : { tipo: 'normal' }} />
  }

  if (sesion.estado === 'revocado') return <Ingreso estado={{ tipo: 'revocado' }} />

  if (sesion.estado === 'error') {
    return (
      <main className="flex min-h-dvh items-center justify-center p-6 text-center text-sm text-tinta-suave">
        No pudimos cargar tu sesión. Revisá tu conexión y probá de nuevo.
      </main>
    )
  }

  const destino = destinoInicial(sesion)
  if (!destino)
    return <Ingreso estado={{ tipo: 'sin_proyectos', email: sesion.usuario.email }} />

  return <Navigate to={destino} replace />
}
